import { useContext } from "react";
import { ComponentContext } from "../context/ComponentContext";

export default function useComponentContext() {
  return useContext(ComponentContext);
}
